class CollectionAttributeSidebar {
  constructor(collectionTags) {
    this._collectionTagsGlobal = collectionTags;
    this._collectionTags = [];
    this._filterCollectionTags = [];
    this._filterData = {};
    this._priceData = [];
    this._appliedFilters = [];
    this._blockedSections = [
      'Pricing Category'
    ]
    this._productsToRemove = [];
    this._currentSortBy = {
      optionValue: "default",
      dataSort: "default",
    };
    this._currentPaginationState = {
      paginationIsVisible: true,
      paginationWrapper: null,
    };
    this._hasFitment = false;
    this._currentFitment = null;
    this._isTier2Selected = false;
    this._tagsContainer = document.getElementById("tags");

    // Debouncing and request cancellation
    this._filterDebounceTimer = null;
    this._filterDebounceDelay = 150; // ms
    this._currentAbortController = null;

    // Cached DOM references
    this._productGrid = document.getElementById("main-collection-product-grid");
    this._collectionContainer = document.getElementById("collection-container");
    this._loadingOverlay = document.querySelector(".loading-overlay--custom");
    this._paginationWrapper = document.querySelector(".pagination-wrapper");
    this._clearAllBtn = document.getElementById("clear-all-filters");
    this._filteredInventoryContainer = document.getElementById("filtered-inventory");
    this._activeFiltersContainer = document.getElementById("active-filters");
    this._emptyMessage = document.getElementById("collection-empty-message");
    this._noProductsMessage = document.getElementById("collection-no-products-message");
    this._appliedFilterTagsContainer = document.getElementById("applied-filter-tags");

    // In-memory caches (tag queries only — fitment uses DOM, no cache needed)
    this._tagCache = new Map();
    this._tagCacheTTL = 5 * 60 * 1000; // 5 minutes TTL

    // Skip tag re-fetch on initial fitment-only load (Liquid tags are sufficient)
    this._skipNextTagUpdate = false;

    this.initData(this._collectionTagsGlobal);
    this.bindEvents();
    this.loadFiltersFromSession();
  }

  // Getters and setters
  get classState() {
    return {
      collectionTags: this._collectionTags,
      filterData: this._filterData,
      priceData: this._priceData,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy,
      hasFitment: this._hasFitment,
      currentFitment: this._currentFitment,
      isTier2Selected: this._isTier2Selected,
    };
  }

  getState() {
    return this.classState;
  }

  static openFilterSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width =
      "350px";
  }

  openSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width =
      "350px";
  }

  closeSidebar() {
    const sidebar = document.getElementById("collection-attribute-sidebar");
    sidebar.style.width = "0";
    if (sidebar.classList.contains("filter-sidebar-open")) {
      sidebar.classList.remove("filter-sidebar-open");
    }
  }

  async initData(collectionTagsArg) {
    const rawFitmentData = localStorage.getItem("fitmentData");
    let parsedFitmentData = rawFitmentData ? JSON.parse(rawFitmentData) : null;

    const threeDaysInMs = 1000 * 60 * 60 * 24 * 3;
    const lastUpdatedMs = parsedFitmentData?.lastUpdated
    ? Number(parsedFitmentData.lastUpdated)
    : null;

    const isExpired =
    lastUpdatedMs &&
    Number.isFinite(lastUpdatedMs) &&
    Date.now() - lastUpdatedMs > threeDaysInMs;

    if (isExpired) {
    localStorage.removeItem("fitmentData");
    parsedFitmentData = null;
    }

    const hasNonEmptyVehicle =
    parsedFitmentData &&
    Object.keys(parsedFitmentData.currentVehicle || {}).length > 0;

    this._hasFitment = Boolean(hasNonEmptyVehicle);
    this._currentFitment = this._hasFitment
    ? parsedFitmentData.currentVehicle
    : null;
    this._collectionTags = collectionTagsArg;
    const tags = this._collectionTags;
    const tagsContainer = this._tagsContainer;

    // Create Category section first
    const categorySection = this.createCollapsibleSection("Category", true);
    const categorySectionContent = categorySection.querySelector("#category-content");
    tagsContainer.appendChild(categorySection);
    if(tags.filter((tag) => tag.toLowerCase().startsWith("tier2:")).length <= 1 ||
       tags.filter((tag) => tag.toLowerCase().startsWith("tier3:")).length <= 1)
    {
      $(categorySection).hide()
    }
    this.processTags(tags, categorySectionContent, tagsContainer);
  }

  processTags(tags, categorySectionContent, tagsContainer) {
    // Process Tier2 tags for the Category section

    if(tags.filter((tag) => tag.toLowerCase().startsWith("tier2:")).length > 1) {
      tags
      .filter((tag) => tag.toLowerCase().startsWith("tier2:"))
      .forEach((tag) => {
        const [, filterValue] = tag.split(":");
        this.createFilterElements(
          categorySectionContent,
          "Tier2",
          filterValue,
          "tier2"
        );
      });
    }

    if(tags.filter((tag) => tag.toLowerCase().startsWith("tier3:")).length > 1) {
      tags
        .filter((tag) => tag.toLowerCase().startsWith("tier3:"))
        .forEach((tag) => {
          const [, filterValue] = tag.split(":");
          this.createFilterElements(
            categorySectionContent,
            "Tier3",
            filterValue,
            "tier3"
          );
        });
    }

    // Process other tags
    tags.forEach((tag) => {
      if (
        tag.includes(":") &&
        !tag.toLowerCase().startsWith("tier2:") &&
        !tag.toLowerCase().startsWith("tier3:") &&
        !tag.toLowerCase().includes("price")
      ) {
        const [filterType, filterValue] = tag.split(":");
        const transformedFilterType = this.toTitleCase(filterType);

        if (!this._filterData[transformedFilterType]) {
          this._filterData[transformedFilterType] = [];
        }

        this._filterData[transformedFilterType].push(filterValue);
      } else if (tag.toLowerCase().includes("price")) {
        const [, filterValue] = tag.split(":");
        this._priceData.push(Number(filterValue));
      }
    });

    // Create facet filter sections — render all facet types regardless of value count
    for (const [filterType, filterValues] of Object.entries(this._filterData)) {
      if(this._blockedSections.includes(filterType)) continue
      const filterSection = this.createCollapsibleSection(filterType);
      tagsContainer.appendChild(filterSection);

      const contentDiv = filterSection.querySelector(".filter-content");
      filterValues.sort().forEach((filterValue, index) => {
        this.createFilterElements(contentDiv, filterType, filterValue, index);
      });
    }

    // Sort Filters
    const filterSections = document.querySelectorAll(".filter-content");

    function sortAlphaNumeric(a, b) {
      const aText = a.querySelector("label").innerText;
      const bText = b.querySelector("label").innerText;

      const aNum = parseFloat(aText);
      const bNum = parseFloat(bText);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      } else {
        return aText.localeCompare(bText, undefined, { numeric: true });
      }
    }

    for (const filterSection of Array.from(filterSections)) {
      const filterSectionChildren = Array.from(filterSection.children);
      filterSectionChildren.sort(sortAlphaNumeric);
      filterSectionChildren.forEach((child) => {
        filterSection.appendChild(child);
      });
    }
  }

  createFilterElements(container, filterType, filterValue, index) {
    if (filterType === "Tier2") {
      return this.createCategoryFilterElements(
        container,
        filterType,
        filterValue,
        index
      );
    }

    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCategoryFilterElements(container, filterType, filterValue, index) {
    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCollapsibleSection(filterType, isCategorySection = false) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "filter-section";

    const headerDiv = document.createElement("div");
    headerDiv.className = "filter-header";
    headerDiv.innerText = isCategorySection
      ? "Category"
      : this.toTitleCase(
          filterType.toLowerCase().includes("length")
            ? filterType + " (IN)"
            : filterType
        );

    const contentDiv = document.createElement("div");
    contentDiv.className = "filter-content";

    if (isCategorySection) {
      contentDiv.id = "category-content";
    }

    sectionDiv.appendChild(headerDiv);
    sectionDiv.appendChild(contentDiv);

    headerDiv.addEventListener("click", () => {
      const contentDiv = sectionDiv.querySelector(".filter-content");
      contentDiv.classList.toggle("show");
      headerDiv.classList.toggle("active");
    });

    return sectionDiv;
  }

  async resetAndRebuildFilters(collectionTagsArg) {
    const tagsContainer = this._tagsContainer;
    this._filterData = {};
    tagsContainer.innerHTML = "";

    await this.initData(collectionTagsArg);

    this.bindCheckboxEvents();
    this.setAppliedFacetFiltersChecked();
  }

  bindEvents() {
    document
      .getElementById("open-sidebar")
      .addEventListener("click", () => this.openSidebar());
    document
      .getElementById("close-sidebar")
      .addEventListener("click", () => this.closeSidebar());
    window.addEventListener("click", (event) => {
      const sidebar = document.getElementById("collection-attribute-sidebar");
      const openButton = document.getElementById("open-sidebar");

      if (
        !sidebar.contains(event.target) &&
        event.target !== openButton &&
        !sidebar.classList.contains("filter-sidebar-open")
      ) {
        this.closeSidebar();
      }
    });
    this.bindCheckboxEvents();

    this._clearAllBtn.addEventListener("click", () => this.clearAllFilters());

    this.initLoadMoreIntegration();
  }

  handleFilterChange(event) {
    const filterType = event.target.name;
    const filterValue = event.target.value;

    if (event.target.checked) {
      this.addFilter(filterType, filterValue);
    } else {
      this.removeFilter(filterType, filterValue);
    }

    if (this._appliedFilters.length > 0) {
      this._clearAllBtn.style.display = "block";
    } else {
      this._clearAllBtn.style.display = "none";
    }
    this.saveFiltersToSession();
    this.applyFilters();
  }

  addFilter(filterType, filterValue) {
    if (filterType.includes("Tier2")) this.handleTier2Selection();

    let currentFilterTag = "";
    const currentTagLowerCase =
      filterType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (!this._appliedFilters.includes(currentFilterTag)) {
      this._appliedFilters.push(currentFilterTag);
    }
  }

  removeFilter(fitlerType, filterValue) {
    let currentFilterTag = "";
    const currentTagLowerCase =
      fitlerType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (this._appliedFilters.includes(currentFilterTag)) {
      const index = this._appliedFilters.indexOf(currentFilterTag);
      this._appliedFilters.splice(index, 1);
    }
  }

  async handleTier2Selection() {
    this._isTier2Selected = true;
  }

  clearAllFilters() {
    this._appliedFilters = [];
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.checked = false;
    });
    this._clearAllBtn.style.display = "none";
    this.saveFiltersToSession();
    this.applyFilters();
  }

  // Debounced applyFilters — cancels in-flight requests on rapid clicks
  applyFilters() {
    if (this._filterDebounceTimer) {
      clearTimeout(this._filterDebounceTimer);
    }
    if (this._currentAbortController) {
      this._currentAbortController.abort();
    }
    this._filterDebounceTimer = setTimeout(() => {
      this._applyFiltersInternal();
    }, this._filterDebounceDelay);
  }

  async _applyFiltersInternal() {
    const _tTotal = performance.now();
    this._currentAbortController = new AbortController();
    this.toggleLoading(true);
    this._loadedProductCount = 0;

    try {
      const newProductGrid = await this.getFilteredProducts();
      if (this._currentAbortController.signal.aborted) return;

      this.renderProductList(newProductGrid);
      this.renderAppliedFilterTags();
      this.handleAppliedFilters();

      this.toggleLoading(false);
      console.log(`[PLP] Total load time: ${Math.round(performance.now() - _tTotal)}ms`);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error("Error applying filters:", error);
        this.toggleLoading(false);
      }
    }
  }

  handleAppliedFilters() {
    const filterContainer = this._activeFiltersContainer;
    if (!filterContainer) return;
    filterContainer.innerHTML = '';

    for (let i = 0; i < this._appliedFilters.length; i++) {
      const div = document.createElement('div');
      div.classList.add('filter-tag');

      const span = document.createElement('span');
      span.classList.add('filter-label');
      span.textContent = this._appliedFilters[i].replace(/tier\d+: /g, '');

      const button = document.createElement('button');
      button.classList.add('remove-filter');
      button.innerHTML = '✕';

      button.addEventListener("click", () => {
        const [filterType, filterValue] = this._appliedFilters[i].split(":");
        this.removeFilter(filterType, filterValue);
        this.saveFiltersToSession();
        this.applyFilters();
        this.handleAppliedFilters();
      });

      div.appendChild(span);
      div.appendChild(button);
      filterContainer.appendChild(div);
    }
  }

  async processProductData(collectionHandle) {
    const hasFilters = this._appliedFilters.length > 0 || this._hasFitment;
    const isDefaultSort = this._currentSortBy.optionValue === "default";

    let concatenatedFilters = null;
    if (hasFilters) {
      concatenatedFilters = this._appliedFilters
        .map((filter) => this.handleizeTag(filter))
        .join("+");
    }

    try {
      if (hasFilters && isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          null
        );
        return sortBy(products, this._currentSortBy);
      } else if (hasFilters && !isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          "title-ascending"
        );
        return products;
      } else if (!hasFilters) {
        const products = await this.fetchUnfilteredSortedProductData(
          collectionHandle,
          "title-ascending"
        );
        return products;
      } else {
        console.warn("Unhandled case in processProductData");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchProductData(collectionHandle, concatenatedFilters, sortKey) {
    const url = sortKey
      ? `/collections/${collectionHandle}/${concatenatedFilters}?sort_by=title-ascending`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          concatenatedFilters
        )}?sort_by=title-ascending`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async fetchUnfilteredSortedProductData(collectionHandle, sortKey) {
    const url = !this._hasFitment
      ? `/collections/${collectionHandle}?sort_by=${sortKey}`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          null
        )}?sort_by=${sortKey}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async addConcatenatedUrlFitmentFilters(hasFitment, concatenatedFilters) {
    const fitment = await JSON.parse(localStorage.getItem("fitmentData"))
      .currentVehicle;

    let handleized;
    let modifiedUrl = "";

    if (hasFitment) {
      handleized = Object.keys(fitment).reduce((acc, key) => {
        if (key !== "submodel") {
          acc[key] = fitment[key] ? this.handleizeTag(fitment[key]) : null;
        }
        return acc;
      }, {});

      const fitmentValues = Object.values(handleized).filter(Boolean).join("+");

      modifiedUrl = concatenatedFilters
        ? `${concatenatedFilters}+${fitmentValues}`
        : fitmentValues;
    } else {
      modifiedUrl = concatenatedFilters || "";
    }

    return hasFitment ? modifiedUrl : concatenatedFilters;
  }

  async handlePagination(newPaginationWrapper) {
    this._currentPaginationState.paginationWrapper = newPaginationWrapper;
    this._currentPaginationState.paginationIsVisible =
      Boolean(newPaginationWrapper);
  }

  async getFilteredProducts() {
    try {
      const collectionHandle = window.location.pathname.split("/")[2];

      // Fire tag update as detached promise — fully decoupled from grid render.
      // handleCollectionTagsUpdate() manages its own loading spinner via toggleFilterLoading()
      // and calls updateCollectionTags() → resetAndRebuildFilters() when done.
      const _tTags = performance.now();
      if (this._skipNextTagUpdate) {
        this._skipNextTagUpdate = false;
      } else {
        this.handleCollectionTagsUpdate().then(() => {
          console.log(`[PLP] Filter facets updated: ${Math.round(performance.now() - _tTags)}ms (background)`);
        });
      }

      const tFetch = performance.now();
      const sortedProducts = await this.processProductData(collectionHandle);
      console.log(`[PLP] Fetch + sort: ${Math.round(performance.now() - tFetch)}ms`);

      const productUl = this._productGrid.cloneNode(false);
      sortedProducts.forEach((product) => productUl.appendChild(product));
      const newProductGrid = document.createElement("div");
      newProductGrid.appendChild(productUl);

      if (this._hasFitment) {
        const _tFitment = performance.now();
        this.applyFitmentToProductData(newProductGrid); // synchronous — DOM read
        console.log(`[PLP] Fitment matching: ${Math.round(performance.now() - _tFitment)}ms`);
      }

      return newProductGrid;
    } catch (error) {
      console.error("Error getting filtered products: ", error);
    }
  }

  renderProductList(productHtml) {
    const container = this._collectionContainer;
    const productList = this._productGrid;
    const emptyMessage = this._emptyMessage;
    const noProductsMessage = this._noProductsMessage;
    const totalProducts = parseInt(container.dataset.totalProducts, 10);

    // Clear existing products
    productList.innerHTML = "";

    // Add filtered products — no re-sort, products are already in correct order from processProductData
    const filteredProducts = productHtml.querySelectorAll(
      ".product-masonry-item"
    );

    Array.from(filteredProducts).forEach((product) => {
      productList.appendChild(product.cloneNode(true));
    });

    // Remove non-fitting products
    if (this._productsToRemove.length > 0) {
      this._productsToRemove.forEach((sku) => {
        this.removeNonFittingProduct(sku);
      });
      this._productsToRemove = [];
    }

    const visibleProducts = productList.querySelectorAll(
      ".product-masonry-item"
    ).length;

    if (visibleProducts === 0) {
      productList.style.display = "none";
      if (totalProducts > 0) {
        emptyMessage.style.display = "block";
        noProductsMessage.style.display = "none";
      } else {
        emptyMessage.style.display = "none";
        noProductsMessage.style.display = "block";
      }
    } else {
      productList.style.display = "block";
      emptyMessage.style.display = "none";
      noProductsMessage.style.display = "none";
    }

    // Handle pagination
    const paginationWrapper = this._paginationWrapper;
    if (paginationWrapper) {
      if (
        visibleProducts > 0 &&
        this._currentPaginationState.paginationIsVisible
      ) {
        paginationWrapper.style.display = "block";
        if (this._currentPaginationState.paginationWrapper) {
          paginationWrapper.innerHTML =
            this._currentPaginationState.paginationWrapper.innerHTML;
        }
      } else {
        paginationWrapper.style.display = "none";
      }
    }

    // Resize grid items
    this.resizeAllGridItems();

    // Update product count if applicable
    const productCountElement = document.querySelector(
      ".toolbar__product-count"
    );
    if (productCountElement) {
      productCountElement.textContent = `${visibleProducts} products`;
    }
  }

  resizeAllGridItems() {
    const allItems = document.getElementsByClassName("product-masonry-item");
    for (let x = 0; x < allItems.length; x++) {
      this.resizeGridItem(allItems[x]);
    }
    const grid = document.getElementsByClassName("halo-row--masonry")[0];
    if (grid) {
      grid.classList.add("is-show");
    }
  }

  resizeGridItem(item) {
    const grid = document.getElementsByClassName("halo-row--masonry")[0];
    if (!grid) return;
    const rowHeight = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-auto-rows")
    );
    const rowGap = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-row-gap")
    );
    const rowSpan = Math.ceil(
      (item.querySelector(".product-item").getBoundingClientRect().height +
        rowGap) /
        (rowHeight + rowGap)
    );
    item.style.gridRowEnd = "span " + rowSpan;
  }

  renderAppliedFilterTags() {
    const tagsContainer = this._appliedFilterTagsContainer;
    tagsContainer.innerHTML = "";

    this._appliedFilters.forEach((filter) => {
      const filterValue = filter.split(":")[1];
      const tagElement = document.createElement("div");
      tagElement.className = "applied-filter-tag";
      tagElement.textContent = filterValue;

      const removeButton = document.createElement("button");
      removeButton.textContent = "x";
      removeButton.className = "remove-filter-button";

      removeButton.addEventListener("click", () => {
        const [filterType, filterValue] = filter.split(":");
        this.removeFilter(filterType, filterValue);

        const checkboxSelector = `.filter-checkbox[name='${filterType}'][value='${filterValue}']`;
        const correspondingCheckbox = document.querySelector(checkboxSelector);

        if (correspondingCheckbox) {
          correspondingCheckbox.checked = false;
        }
        this.saveFiltersToSession();
        this.applyFilters();
      });

      tagElement.appendChild(removeButton);
      tagsContainer.appendChild(tagElement);
    });

    const clearAllFiltersLink = this._clearAllBtn;
    if (this._appliedFilters.length > 0) {
      clearAllFiltersLink.style.display = "block";
    } else {
      clearAllFiltersLink.style.display = "none";
    }

    const filterComponent = document.getElementById(
      "collection-attribute-sidebar"
    );
    const openButton = document.getElementById("open-sidebar");
    const hasAvailableFilters =
      Object.keys(this._filterData).length > 0 || this._priceData.length > 0;
  }

  async handleCollectionTagsUpdate() {
    this.toggleFilterLoading(true);
    const newTags =
      !this._hasFitment && this._appliedFilters.length === 0
        ? await this.getAllCollectionTags()
        : await this.getAllFilteredTags();
    this.updateCollectionTags(newTags);
  }

  async getAllCollectionTags() {
    try {
      const collectionHandle = window.location.pathname.split("/").pop();
      const cacheKey = `all-tags-${collectionHandle}`;

      const cached = this._tagCache.get(cacheKey);
      if (cached && Date.now() - cached.timestamp < this._tagCacheTTL) {
        return cached.data;
      }

      let tagsFlat = [];
      let hasNextPage = true;
      let lastCursor = null;

      while (hasNextPage) {
        let afterCursor = lastCursor ? `, after: "${lastCursor}"` : "";
        let collectionQuery = `
          query {
            collectionByHandle(handle: "${collectionHandle}") {
              products(first: 250${afterCursor}) {
                pageInfo {
                  hasNextPage
                }
                edges {
                  cursor
                  node {
                    tags
                  }
                }
              }
            }
          }`;

        const response = await makeGraphQLRequest(collectionQuery);

        if (!response || !response.data) {
          throw new Error("Invalid response from the server");
        }

        hasNextPage =
          response.data.collectionByHandle.products.pageInfo.hasNextPage;
        const edges = response.data.collectionByHandle.products.edges;

        if (edges.length > 0) {
          lastCursor = edges[edges.length - 1].cursor;

          const tags = edges.map((edge) => edge.node.tags);
          tagsFlat = tagsFlat.concat(tags.flat());
        } else {
          hasNextPage = false;
        }
      }

      this._tagCache.set(cacheKey, { data: tagsFlat, timestamp: Date.now() });
      return tagsFlat;
    } catch (error) {
      console.error("Error getting collection tags: ", error);
      return [];
    }
  }

  async getAllFilteredTags() {
    const collectionHandle = window.location.pathname.split("/").pop();
    const hasFitment = this._hasFitment && this._currentFitment && Object.keys(this._currentFitment).length > 0;

    // Build cache key from filter state + fitment
    const fitmentKey = hasFitment ? JSON.stringify(this._currentFitment) : 'none';
    const filtersKey = this._appliedFilters.sort().join('|');
    const cacheKey = `filtered-tags-${collectionHandle}-${filtersKey}-${fitmentKey}`;

    const cached = this._tagCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < this._tagCacheTTL) {
      return cached.data;
    }

    let allTags = [];
    let hasNextPage = true;
    let cursor = null;

    while (hasNextPage) {
      const afterArg = cursor ? `, after: "${cursor}"` : "";
      const filterObjs = this._appliedFilters.map(f =>
        `{tag: "${f.replace(/"/g, '\\"')}"}`
      );
      const filtersArg = filterObjs.length ? `, filters: [${filterObjs.join(",")}]` : "";

      const query = hasFitment
        ? `query { collection(handle: "${collectionHandle}") {
            products(first: 250${filtersArg}${afterArg}) {
              pageInfo { hasNextPage }
              edges { cursor node { tags variants(first: 100) { edges { node {
                sku
                metafield(namespace: "pim", key: "fitment_details") { value }
              }}}}}
            }
          }}`
        : `query { collection(handle: "${collectionHandle}") {
            products(first: 250${filtersArg}${afterArg}) {
              pageInfo { hasNextPage }
              edges { cursor node { tags } }
            }
          }}`;

      const resp = await makeGraphQLRequest(query);

      if (!resp || !resp.data || !resp.data.collection) {
        hasNextPage = false;
        break;
      }

      const edges = resp.data.collection.products.edges;
      hasNextPage = resp.data.collection.products.pageInfo.hasNextPage;

      if (edges.length > 0) {
        cursor = edges[edges.length - 1].cursor;
      } else {
        hasNextPage = false;
      }

      for (const edge of edges) {
        if (hasFitment) {
          // Variant-level fitment checking — check ALL variants
          const variantEdges = edge.node.variants?.edges || [];
          let hasAnyFitmentData = false;
          let hasMatchingVariant = false;

          for (const variantEdge of variantEdges) {
            const mf = variantEdge.node?.metafield;
            if (mf && mf.value) {
              hasAnyFitmentData = true;
              if (isSubmodelMatch(mf.value, this._currentFitment)) {
                hasMatchingVariant = true;
                break;
              }
            }
          }

          // Universal fit (no metafield on any variant) OR at least one variant matches
          if (!hasAnyFitmentData || hasMatchingVariant) {
            allTags.push(...edge.node.tags);
          }
        } else {
          allTags.push(...edge.node.tags);
        }
      }
    }

    const uniqueTags = [...new Set(allTags)];
    this._tagCache.set(cacheKey, { data: uniqueTags, timestamp: Date.now() });
    return uniqueTags;
  }

  async updateCollectionTags(newTags) {
    try {
      let tags = [];
      newTags.forEach((tag) => {
        if (!tags.includes(tag)) {
          tags.push(tag);
        }
      });
      this._collectionTags = tags;
      await this.resetAndRebuildFilters(this._collectionTags);
      this.toggleFilterLoading(false);
    } catch (error) {
      console.error("Error updating collection tags: ", error);
    }
  }

  // Reads fitment from DOM data-fitment-detail attribute — zero API calls, synchronous
  applyFitmentToProductData(productDataHtml) {
    const currentFitment = this._currentFitment;
    if (!currentFitment || Object.keys(currentFitment).length === 0) return;

    const elements = productDataHtml.querySelectorAll(
      "#main-collection-product-grid li > div"
    );
    if (elements.length === 0) return;

    for (const element of elements) {
      const fitmentDetail = element.getAttribute("data-fitment-detail");
      const variantObj = parseVariantData(element);
      const sku = variantObj?.variantSku;
      if (!sku) continue;

      // Empty/missing = universal fit (always included)
      if (fitmentDetail && fitmentDetail.trim().length > 0) {
        // Split by semicolon to check all variant fitment entries
        const entries = fitmentDetail.split(";").filter(e => e.trim().length > 0);
        let hasMatch = false;

        for (const entry of entries) {
          if (isSubmodelMatch(entry, currentFitment)) {
            hasMatch = true;
            break;
          }
        }

        if (!hasMatch && entries.length > 0) {
          this._productsToRemove.push(sku);
        }
      }
    }
  }

  // Pure filter — returns only fitment-matching products from an array of elements
  applyFitmentToNewProducts(productElements) {
    const currentFitment = this._currentFitment;
    if (!currentFitment || Object.keys(currentFitment).length === 0) return productElements;

    return productElements.filter((element) => {
      const productItem = element.querySelector(".product-item");
      if (!productItem) return true;

      const fitmentDetail = productItem.getAttribute("data-fitment-detail");
      // Empty/missing = universal fit
      if (!fitmentDetail || fitmentDetail.trim().length === 0) return true;

      // Split by semicolon to check all variant fitment entries
      const entries = fitmentDetail.split(";").filter(e => e.trim().length > 0);
      for (const entry of entries) {
        if (isSubmodelMatch(entry, currentFitment)) return true;
      }
      return entries.length === 0;
    });
  }

  removeNonFittingProduct(sku) {
    const elements = document.querySelectorAll(
      "#main-collection-product-grid li > div"
    );

    elements.forEach((element) => {
      const variantObjSku = parseVariantData(element).variantSku;
      if (variantObjSku === sku) {
        element.parentElement.remove();
      }
    });
    return;
  }

  toggleLoading(show) {
    const loadingOverlay = this._loadingOverlay;
    if (show) {
      loadingOverlay.style.display = "block";
    } else {
      loadingOverlay.style.display = "none";
    }
  }

  toggleFilterLoading(show) {
    const tagsDiv = document.getElementById("tags");
    if (show) {
      if (!tagsDiv.querySelector("#js-loading-div")) {
        const loadingDiv = `<div id="js-loading-div" class="loading-overlay loading-overlay--custom" style="display: block;">
                    <div class="loading-overlay__spinner" aria-label="Loading"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
                </div>`;
        tagsDiv.insertAdjacentHTML("afterbegin", loadingDiv);
      }
    } else {
      const spinner = tagsDiv.querySelector("#js-loading-div");
      if (spinner) spinner.remove();
    }
  }

  toTitleCase(str) {
    return str
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/(\b[a-z](?!\s))/g, (x) => x.toUpperCase());
  }

  handleizeTag(input) {
    return input
      .toLowerCase()
      .replace(/:/g, "-")
      .replace(/\./g, "-")
      .replace(/[^a-z0-9-\s]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  setLoadingState() {
    this._sidebar.classList.add("loading");
  }

  saveFiltersToSession() {
    const state = {
      selectedPriceRange: this._selectedPriceRange,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy.optionValue,
    };
    sessionStorage.setItem(
      `fitlers-${window.location.pathname.split("/")[2]}`,
      JSON.stringify(state)
    );
  }

  loadFiltersFromSession() {
    const savedState = sessionStorage.getItem(
      `fitlers-${window.location.pathname.split("/")[2]}`
    );

    if (savedState) {
      const state = JSON.parse(savedState);
      this._selectedPriceRange = state.selectedPriceRange || { min: 0, max: 0 };
      this._appliedFilters = state.appliedFilters || [];
      this._currentSortBy.optionValue =
        state.currentSortBy.optionValue || "default";

      this.setAppliedFacetFiltersChecked();

      // Only call applyFilters() when there are active filters OR fitment
      if (this._appliedFilters.length > 0 || this._hasFitment) {
        this.applyFilters();
      }

      if (this._appliedFilters.length > 0) {
        this._clearAllBtn.style.display = "block";
      } else {
        this._clearAllBtn.style.display = "none";
      }
    } else {
      this.saveFiltersToSession();
      // No saved state — only call applyFilters() if fitment is active
      if (this._hasFitment) {
        this.applyFilters();
      }
    }
  }

  setAppliedFacetFiltersChecked() {
    this._appliedFilters.forEach((filterTag) => {
      const [filterType, filterValue] = filterTag.split(":");
      const checkboxSelector = `.filter-checkbox[name='${this.toTitleCase(
        filterType
      )}'][value='${filterValue}']`;
      const checkboxElement = document.querySelector(checkboxSelector);
      if (checkboxElement) {
        checkboxElement.checked = true;
      }
    });
  }

  bindCheckboxEvents() {
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", (event) =>
        this.handleFilterChange(event)
      );
    });
  }

  // Load More Integration — MutationObserver detects new products appended by the theme
  initLoadMoreIntegration() {
    if (!this._productGrid) return;

    const observer = new MutationObserver((mutations) => {
      const addedProducts = [];
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList?.contains("product-masonry-item")) {
            addedProducts.push(node);
          }
        }
      }
      if (addedProducts.length === 0) return;

      // Apply fitment to newly appended products
      if (this._hasFitment) {
        for (const product of addedProducts) {
          const productItem = product.querySelector(".product-item");
          if (!productItem) continue;

          const fitmentDetail = productItem.getAttribute("data-fitment-detail");
          if (!fitmentDetail || fitmentDetail.trim().length === 0) continue;

          const entries = fitmentDetail.split(";").filter(e => e.trim().length > 0);
          let hasMatch = false;
          for (const entry of entries) {
            if (isSubmodelMatch(entry, this._currentFitment)) {
              hasMatch = true;
              break;
            }
          }
          if (!hasMatch && entries.length > 0) {
            product.remove();
          }
        }
      }

      // Recalculate masonry layout
      this.resizeAllGridItems();

      // Re-initialize theme features
      this.runThemePostProcessing();

      this.toggleLoading(false);
    });

    observer.observe(this._productGrid, { childList: true });
  }

  runThemePostProcessing() {
    // Re-initialize Currency conversion if available
    if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
      try {
        Currency.convertAll(
          window.shopCurrency || 'USD',
          jQuery('[name=currencies]').val() || window.shopCurrency || 'USD'
        );
      } catch (e) {
        // Currency conversion not available
      }
    }

    // Re-initialize SPR badges if available
    if (typeof SPR !== 'undefined' && typeof SPR.initDomEls === 'function') {
      try {
        SPR.initDomEls();
        SPR.loadBadges();
      } catch (e) {
        // SPR not available
      }
    }
  }
}

const collectionAttributeSidebar = new CollectionAttributeSidebar(
  collectionTags
);

// Helper functions
function sortBy(products, currentSortBy) {
  switch (currentSortBy.optionValue) {
    case "low-to-high":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceA - priceB;
      });
    case "high-to-low":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceB - priceA;
      });
    case "alpha-asc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleA.localeCompare(titleB);
      });
    case "alpha-desc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleB.localeCompare(titleA);
      });
    default:
      return products.sort((a, b) => {
        const priceElA = a.querySelector(".card-price");
        const priceElB = b.querySelector(".card-price");
        const priceA = priceElA
          ? parseFloat(priceElA.textContent.replace(/[^0-9.]/g, "")) || 0
          : 0;
        const priceB = priceElB
          ? parseFloat(priceElB.textContent.replace(/[^0-9.]/g, "")) || 0
          : 0;
        return priceB - priceA;
      });
  }
}

function parseVariantData(element) {
  const jsonData = element.getAttribute("data-json-product");
  const decodedStr = decodeURIComponent(jsonData);
  const parsedObj = JSON.parse(decodedStr);
  return {
    productTitle: parsedObj.variants[0].name,
    variantSku: parsedObj.variants[0].sku,
  };
}

async function makeGraphQLRequest(query) {
  try {
    const response = await fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "44daa33a01b8f97dc5ae653f16dda25a",
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      console.error(`GraphQL request failed: ${response.status} ${response.statusText}`);
      return { data: null, errors: [{ message: `HTTP ${response.status}` }] };
    }

    const json = await response.json();
    if (json.errors && json.errors.length > 0) {
      console.error("GraphQL errors:", json.errors);
    }
    return json;
  } catch (error) {
    console.error("GraphQL request error:", error);
    return { data: null, errors: [{ message: error.message }] };
  }
}

function isSubmodelMatch(fitmentStrings, fitmentSelection) {
  const { year, make, model, submodel, drive_type, fuel_type } =
    fitmentSelection;

  function stringToObject(fitmentStrings) {
    return fitmentStrings.split(";").map((str) => {
      const [year, make, model, sub_model, drive_type, fuel_type] =
        str.split("|");
      return { year, make, model, sub_model, drive_type, fuel_type };
    });
  }

  function isMatch(fitmentValue, inputValue, wildcard = "*") {
    return (
      inputValue &&
      fitmentValue &&
      (fitmentValue.toLowerCase() === inputValue.toLowerCase() ||
        fitmentValue.toLowerCase() === wildcard)
    );
  }

  const fitmentStringArray = stringToObject(fitmentStrings);
  let isSubModelMatch = false;

  for (const fitment of fitmentStringArray) {
    const yearMatch = fitment.year === year;
    const makeMatch = isMatch(fitment.make, make);
    const modelMatch = isMatch(fitment.model, model);
    const driveTypeMatch = isMatch(fitment.drive_type, drive_type);
    const fuelTypeMatch = isMatch(fitment.fuel_type, fuel_type);
    const submodelMatch = isMatch(fitment.sub_model, submodel);

    if (
      yearMatch &&
      makeMatch &&
      modelMatch &&
      (driveTypeMatch || driveTypeMatch === undefined) &&
      (fuelTypeMatch || fuelTypeMatch === undefined) &&
      (submodelMatch || submodelMatch === undefined)
    ) {
      isSubModelMatch = true;
      break;
    }
  }

  return isSubModelMatch;
}

// Open sidebar externally
function toggleFilterSidebar() {
  const sidebar = document.getElementById("collection-attribute-sidebar");
  if (sidebar.classList.contains("filter-sidebar-open")) {
    sidebar.classList.remove("filter-sidebar-open");
  } else {
    sidebar.classList.add("filter-sidebar-open");
  }
}
